import { render, staticRenderFns } from "./UzAsbo.vue?vue&type=template&id=65bb2ccd&scoped=true&"
import script from "./UzAsbo.vue?vue&type=script&lang=js&"
export * from "./UzAsbo.vue?vue&type=script&lang=js&"
import style0 from "./UzAsbo.vue?vue&type=style&index=0&id=65bb2ccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb2ccd",
  null
  
)

export default component.exports